import { z } from 'zod'

// Base schema for server-side validation (no translations needed)
export const loginSchemaBase = z.object({
  identity: z.string().min(1),
  password: z.string().min(6)
})

// Client-side schema with translations
type LoginSchemaProps = {
  t: Translations<'auth.login.validation'>
}

export const loginSchema = ({ t }: LoginSchemaProps) =>
  z.object({
    identity: z.string().min(1, { message: t('identityRequired') }),
    password: z.string().min(6, { message: t('passwordMinLength') })
  })

export type LoginSchema = z.infer<typeof loginSchemaBase>
